module.exports = __webpack_public_path__ + "img/20210420_122108.74c3886b.jpg";